export default __webpack_public_path__ + "static/media/DSC_9081-edited.363d01e2.jpg";